function getDateISOString(date: Date) {
  const convertedOffset = -date.getTimezoneOffset() * 60 * 1000; // 분 단위 오프셋을 가져옴
  const utcDate = new Date(date.getTime() + convertedOffset); // UTC 시간으로 변환
  const requestDate = utcDate.toISOString().slice(0, 19);

  return requestDate;
}

export default getDateISOString;
